// @flow
import { createContext } from 'react';


/**
 * Контекст для передачи данных в корзину
 * availableUuids: объект с uuids по которым будут фильтроваться точки доставки
 */

type AvailableUuidsType = { [string]: true };
const availableUuids: AvailableUuidsType = {};

// $FlowFixMe
const ContextForCart = createContext({
  availableUuids,
});

export default ContextForCart;
